import { useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Header from '../components/Header';

export default function Layout({ children }) {

  const { pathname } = useLocation();

  return(
    !(pathname.includes('userVerify')) ?
    <Box pt={'92.5px'}>
      { !( pathname.includes('login')|| pathname.includes('userVerify'))  && <Header /> }
      { children }
    </Box>
    :<Box>
    { children }
  </Box>
  );
};
